export const defaultPageOptions = [10, 20, 50];
export const customPageOptions = [20, 50, 100, 500];
export const dateFormatList = ['dd/MM/yyyy', 'MM/dd/yyyy', 'yyyy/MM/dd'];
export const dateTimeFormatList = ['dd/MM/yyyy HH:mm', 'MM/dd/yyyy HH:mm', 'yyyy/MM/dd HH:mm'];
